import React, { useEffect, useState, useRef } from "react";
import moment from "jalali-moment";

// import JS files
import RingNumbersEdit from "../../shares/RingNumbersEdit";
import { useCustomerBasket } from "../../../context/CustomerBasketContext";
import MuiDatePicker from "../../shares/MuiDatePicker";
import { fixNumbers } from "../../../utils";
import MuiButtonRef from "../../shares/MuiButtonRef";
import { useSetting } from "../../../context/SettingContext";
import useFetch from "../../../context/useFetch";
import { toast } from "react-toastify";
// import { defaultRingSize, reverseShowNums } from "../../../constants/constants";

const OrderCardLeftPart = (props) => {
  const { defaultRingSize, reverseShowNums } = useSetting();
  const [dateValue, setDateValue] = useState(moment());

  function dateOnChange(date) {
    setDateValue(date);
  }
  const [nums, setNums] = useState(new Array(defaultRingSize + 1).fill(""));
  const { AddRing } = useCustomerBasket();
  const update_nums = (ind, nValue) => {
    // if (reverseShowNums) {
    //   ind = defaultRingSize - ind;
    // }
    let beforeNums = [...nums];
    beforeNums[ind] = fixNumbers(nValue);
    setNums(beforeNums);
  };

  const add_new_ring = () => {
    AddRing(
      props.item,
      nums,
      dateValue,
      props.selectedUser !== undefined ? props.selectedUser : null
    );

    if (props.emptySearchData !== undefined) {
      props.empty_search();
    }
    if (props.hasOpenModal != undefined) props.setOpenModal(false);
  };

  const htmlElRef = useRef(null);
  const useFocus = () => {
    const setFocus = () => {
      htmlElRef.current && htmlElRef.current.focus();
    };

    return [htmlElRef, setFocus];
  };
  const [inputRef, setInputFocus] = useFocus();
  let random_num = Math.random() * 10;

  const [checkDisable, setCheckDisable] = useState(true);
  useEffect(() => {
    for (let index = 0; index < nums.length; index++) {
      if (nums[index] !== "0" && nums[index] !== "") {
        setCheckDisable(false);
        return;
      }
      else{
        setCheckDisable(true);
      }
    }
  }, [nums]);

  return (
    <>
      <div className="md:grid grid-cols-12 gap-x-2 items-center">
        <div className="md:col-span-9">
          <RingNumbersEdit
            item={props.item}
            dynamicMap
            nums={nums}
            update_nums={update_nums}
            random_num={random_num}
          />
        </div>
        <div className="md:col-span-3 grid grid-cols-2 md:grid-cols-3 mt-4">
          <div className="md:col-span-2 mr-2 md:mr-0" tabIndex="-1">
            <MuiDatePicker onChange={dateOnChange} value={dateValue} />
          </div>
          <div
            className="md:col-span-1 text-left mt-1 amin"
            tabIndex={defaultRingSize + 2 + random_num}
            onFocus={setInputFocus}
          >
            <MuiButtonRef
              ref={inputRef}
              onClick={add_new_ring}
              variant="contained"
              color="success"
              text="افزودن"
              size="small"
              disabled={checkDisable}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default OrderCardLeftPart;
